import type { DeviceDto } from "@/lib/api/types";

/** Static mock catalog — aligned with typical `DeviceDto` API responses. */
export const MOCK_DEVICES: DeviceDto[] = [
  {
    id: "33333333-3333-3333-3333-333333333301",
    name: "Gateway North — acquisition hut",
    device_uid: "DL-MOCK-001",
    status: "online",
    firmware_version: "2.4.1",
    metadata: { site: "Pune", model: "Atech DL-1000", elevation_m: 520 },
    last_seen: new Date(Date.now() - 120_000).toISOString(),
  },
  {
    id: "33333333-3333-3333-3333-333333333302",
    name: "Weather pod East",
    device_uid: "DL-MOCK-002",
    status: "online",
    firmware_version: "2.3.8",
    metadata: { sensors: ["temp", "rh", "pressure"] },
    last_seen: new Date(Date.now() - 45_000).toISOString(),
  },
  {
    id: "33333333-3333-3333-3333-333333333303",
    name: "Vibration logger — Bay 4",
    device_uid: "DL-MOCK-003",
    status: "maintenance",
    firmware_version: "2.2.0",
    metadata: { axis: "triaxial", site: "Plant A" },
    last_seen: new Date(Date.now() - 3_600_000).toISOString(),
  },
  {
    id: "33333333-3333-3333-3333-333333333304",
    name: "Legacy field RTU",
    device_uid: "DL-MOCK-004",
    status: "offline",
    firmware_version: "1.9.4",
    metadata: { backhaul: "LTE" },
    last_seen: new Date(Date.now() - 86_400_000).toISOString(),
  },
  {
    id: "33333333-3333-3333-3333-333333333305",
    name: "Bench calibration unit",
    device_uid: "DL-MOCK-005",
    status: "online",
    firmware_version: "2.4.1",
    metadata: { mode: "calibration", lab: "QC-1" },
    last_seen: new Date(Date.now() - 15_000).toISOString(),
  },
  {
    id: "33333333-3333-3333-3333-333333333306",
    name: "River gauge — monsoon trial",
    device_uid: "DL-MOCK-006",
    status: "online",
    firmware_version: "2.4.0",
    metadata: { river: "Mula", stage_m: 1.82 },
    last_seen: new Date(Date.now() - 5_000).toISOString(),
  },
];

export const MOCK_DEVICE_IDS = MOCK_DEVICES.map((d) => d.id);
